import { MouseEvent } from 'react';

export type SortingType = 'asc' | 'desc' | undefined;
export type HeaderClickEvent = MouseEvent<HTMLTableCellElement>;
export enum SortingTypeEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export interface IGridSorting {
  orderBy?: string
  direction?: SortingType
}

export interface IGridColumnV1 {
  header: {
    /**
     * Used as title for column header. Sorting available only if a value are set for this prop
     */
    columnName?: string
    /**
     * Classname to customize styles of a header 'th'-element content or to customize wrapper for result of cellRender function if available
     */
    className?: string
    onClick?: (event: HeaderClickEvent, column: IGridColumn) => void
    /**
     * Render-function, result will be wrapped into a header 'th'-element with standard styles, use className property to customize styles
     */
    cellRender?: () => React.ReactElement
    /**
     * Flag for creating a column sortable
     */
    isSortable?: boolean
  }
  dataKey?: string
  /**
   * set a key to send it to server, if not set will be used dataKey. Sorting available only if header.columnName is set
   */
  orderByKey?: string
  /**
   * Classname to customize styles of a 'td'-element content or to customize wrapper for result of cellRender function if available
   */
  className?: string
  /**
   * Render-function, result will be wrapped into 'td'-element with standard styles, use className property to customize styles
   */
  cellRender?: (row: any) => React.ReactElement<HTMLTableElement>
}
export interface IGridColumnV2 {
  header: {
    columnName?: string
    className?: string
    onClick?: (event: HeaderClickEvent, column: IGridColumn) => void
    cellRender?: () => React.ReactElement
    isSortable?: true
  }
  dataKey?: string
  cellRender: (row: any) => React.ReactElement<HTMLTableElement>
}
export type IGridColumn = IGridColumnV1;

export interface IGridHeaderProps {
  columns: IGridColumn[]
  sorting?: IGridSorting
  onColumnHeaderClick?: (event: HeaderClickEvent, column: IGridColumn) => void
  onSortingChange?: (event: HeaderClickEvent, column: IGridColumn) => void
}

export interface IGridHeaderCellProps {
  column: IGridColumn
  sorting?: IGridSorting
  onClick?: (event: HeaderClickEvent, column: IGridColumn) => void
  onSortingChange?: (event: HeaderClickEvent, column: IGridColumn) => void
}

export interface IGridBodyProps {
  data: any[]
  columns: IGridColumn[]
  total: number
  noValueSymbol?: string
  noAd?: boolean
}

export interface IGridRowProps {
  rowData: any
  columns: IGridColumn[]
  className: string,
  noValueSymbol?: string,
}

export interface IGridProps {
  columns: IGridColumn[]
  data: any[]
  total: number
  onSortingChange?: (event: HeaderClickEvent, column: IGridColumn, sorting: IGridSorting) => void
  noValueSymbol?: string
  className?: string
  noAd?: boolean
  defaultSorting?: IGridSorting
  isLoading?: boolean
}
